import "fq-feature/Video/src/Scripts/main";
import { Component } from "fq-foundation/Scripts/Component";

new Component().create("Video", {
    element: ".f-video"
});